import { Box, Typography } from "@mui/material";
import React from "react";

const Description = () => {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
          height: "fit-content",
          width: "70%",
          borderRadius: 2,
          backgroundColor: (theme) => theme.palette.terrain[200],
          border: "1px solid",
          borderColor: (theme) => theme.palette.terrain[300],
          padding: 2,
        }}
      >
        <Typography variant="body2">
          A list of invoices between two dates with line items summarized by
          Expense Groups or Subgroups.
        </Typography>
      </Box>
    </Box>
  );
};

export default Description;
